"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.textToDependencyRelation = exports.clipboardLRToDependencyRelation = void 0;
const utils_1 = require("./utils");
const record_1 = require("../utils/record");
const clipboardLRToDependencyRelation = (clipboardValue, srcField, _targetField, _userPreferences, currentValue, { applicationId }) => {
    var _a;
    if (((_a = srcField.params) === null || _a === void 0 ? void 0 : _a.linked_application) !== applicationId) {
        return currentValue;
    }
    if (!Array.isArray(clipboardValue.rawValue)) {
        return currentValue;
    }
    return recordsToDependencyRelations(clipboardValue.rawValue, applicationId);
};
exports.clipboardLRToDependencyRelation = clipboardLRToDependencyRelation;
const textToDependencyRelation = (appRecordsService) => {
    return async (clipboardValue, _srcField, targetField, _userPreferences, currentValue, { applicationId }) => {
        const text = clipboardValue.text.replace(/\n/g, " ").trim();
        if (!text) {
            return [];
        }
        const titles = (0, utils_1.processClipboardTextValueWithSeparators)(clipboardValue);
        if (!titles.length) {
            return [];
        }
        const textHasSeparators = titles.length > 1;
        if (textHasSeparators) {
            titles.push(text);
        }
        const records = await appRecordsService.recordsByTitleService.fetchRecordsByTitles(applicationId, titles);
        if (records.length === 0) {
            return currentValue;
        }
        const fullTextMatchedRecord = records.find((record) => (0, record_1.getTitle)(record).toLocaleLowerCase() === text.toLocaleLowerCase());
        if (fullTextMatchedRecord) {
            return recordsToDependencyRelations([fullTextMatchedRecord], applicationId);
        }
        return recordsToDependencyRelations(records, applicationId);
    };
};
exports.textToDependencyRelation = textToDependencyRelation;
const recordsToDependencyRelations = (records, applicationId) => {
    return records.map(({ id }) => ({
        record: id,
        application: applicationId,
        type: "fs",
        lag: 0,
    }));
};
